import { mapActions, mapState, mapGetters } from 'vuex'
import { clone } from 'ramda'
import AutocompleteComponent from "@/components/commons/autocomplete/AutocompleteComponent.vue";

export default {
  name: 'BreadcrumbComponent',
  components: {
    AutocompleteComponent
  },
  props: {
    /**
     * tab : {
     *  id: <identificador único del tab>,
     *  name: <nombre del tab>
     * }
     */
    tabs: {
      type: Array,
      required: true
    },
    tabSelected: {
      type: Function,
      required: true
    },
    buttons: {
      type: Array,
      required: false,
      default: () => { return [] }
    }
  },
  data () {
    return {
      selectedEntity: undefined
    }
  },
  mounted () {
    const search = new URLSearchParams(window.location.search)
    const selectedtab = search.get('tab')
    if (selectedtab) {
      this.tabSelected(this.tabs[selectedtab - 1].id)
    }
  },
  computed: {
    /**
     * Se mapea el stado del item seleccionado del store
     */
    ...mapState('reportBreadcrumb', {
      selectedItem: state => state.selectedItem,
    }),
    /**
     * Getters del store
     */
    ...mapGetters({
      'entitySelectorItems': 'reportBreadcrumb/getEntitySelectorItems',
      'entitySelectorConfiguration': 'reportBreadcrumb/getEntitySelectorConfiguration',
      'details': 'reportBreadcrumb/getDetails',
    }),
    /**
     * Ordena los items del selector
     */
    entitySelectorItemsSorted () {
      const selectorItemsCopy = clone(this.entitySelectorItems)
      const that = this
      return selectorItemsCopy.sort(function sortFunction (a, b) {
        const nameA = a[that.entitySelectorConfiguration.text].toLowerCase()
        const nameB = b[that.entitySelectorConfiguration.text].toLowerCase()
        if (nameA < nameB) {
          return -1
        } else if (nameA > nameB) {
          return 1
        } else {
          return 0
        }
      })
    },
  },
  created () {
    this.$store.watch(state => state.reportBreadcrumb.selectedItem, () => {
      if (this.$store.state.reportBreadcrumb.selectedItem) {
        this.selectedEntity = this.$store.state.reportBreadcrumb.selectedItem
      } else if (this.$store.state.reportBreadcrumb.entitySelectorItems && this.$store.state.reportBreadcrumb.entitySelectorItems.length > 0) {
        this.selectedEntity = this.$store.state.reportBreadcrumb.entitySelectorItems[0]
      }
    })
  },
  beforeDestroy () {
  },
  methods: {
    ...mapActions('reportBreadcrumb', [
      'setSelectedItem'
    ]),
    /**
     * Cada vez que se modifica la selección de la entidad, se cargan
     */
    entitySelectedFunction (newValue) {
      this.selectedEntity = newValue;
    },
  },
  watch: {
    selectedEntity () {
      this.setSelectedItem(this.selectedEntity)
    }
  }
}
